<template>
  <generic-modal :title="$t('member')" ref="generic_modal">
    <div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label for="" class="label">{{ $t("type") }}</label>
            <div class="select">
              <select v-model="meta.type">
                <option value="customer">{{ $t("customer") }}</option>
                <option value="coach">{{ $t("coach") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.name" />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("birth date") }}</label>
            <generic-calendar
              type="date"
              display_mode="dialog"
              :is_range="false"
              ref="birthdate_calendar"
              @selected="birthdate_changed"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("phone number") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.phone_number" />
              <span class="icon is-small is-left">
                <i class="fa fa-phone"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("email") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.email" />
              <span class="icon is-small is-left">
                <i class="fa fa-at"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('choosen promotion')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/gym_member/promotion/catalog"
              name_field="name"
              value_field="promotion_id"
              @selected="promotion_changed"
              ref="promotion_dropdown"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("dpi") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.settings.dpi" />
              <span class="icon is-small is-left">
                <i class="fa fa-id-card"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("passport") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="meta.settings.passport"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-id-card"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("nit") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.settings.nit" />
              <span class="icon is-small is-left">
                <i class="fa fa-id-card"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("billing name") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="meta.settings.billing_name"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("billing address") }}</label>
        <div class="control has-icons-left">
          <input
            class="input"
            type="text"
            v-model="meta.settings.billing_address"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-home"></i>
          </span>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("billing zip code") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="meta.settings.billing_zip_code"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-map-marker"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("billing municipality") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="meta.settings.billing_municipality"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-globe"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("billing department") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="meta.settings.billing_department"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-globe"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("photo") }}</label>
        <div class="control">
          <generic-uploader
            ref="generic_uploader"
            :idle_label="$t('drop photo here or click to upload')"
            endpoint_url="/gym_member/photo"
            @error="error_uploading"
            @success="success_uploading"
            :allow_multiple="false"
          />
        </div>
        <!-- <pre>{{ meta }}</pre> -->
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "Gym_memberModal",
  components: {
    GenericModal,
    GenericCalendar,
    GenericDropdown,
    GenericUploader,
  },
  data() {
    return {
      meta: { settings: {} },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        // !v.meta.name || (v.meta.type == "customer" && !v.meta.promotion_id)
        !v.meta.name
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/gym_member", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/gym_member", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        type: "customer",
        phone_number: "",
        email: "",
        birth_date: "",
        promotion_id: "",
        settings: {},
      };
      v.error = "";
      v.$refs.promotion_dropdown.clear();
      v.$refs.birthdate_calendar.clear();
      v.$refs.generic_uploader.clear();
      // v.uuid = "";
    },
    birthdate_changed(date) {
      let v = this;
      v.meta.birth_date = date;
    },
    promotion_changed(promotion) {
      let v = this;
      if (promotion) v.meta.promotion_id = promotion.promotion_id;
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
      };

      v.meta.settings.photo = data;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
